import React from "react";
import { browserName } from "react-device-detect";
import { styled } from "@mui/material/styles";
import Tooltip, { tooltipClasses } from "@mui/material/Tooltip";
import moment from "moment";
import Swal from "sweetalert2";

import gsc from "../assets/images/insuranceLogos/gsc.png";
import equitableLife from "../assets/images/insuranceLogos/equitableLife.png";
import otip from "../assets/images/insuranceLogos/otip.PNG";
import manulife from "../assets/images/insuranceLogos/manulife.PNG";
import mdm from "../assets/images/insuranceLogos/mdm.PNG";
import rwam from "../assets/images/insuranceLogos/rwam.png";
import rbc from "../assets/images/insuranceLogos/rbc.PNG";
import ssq from "../assets/images/insuranceLogos/ssq.webp";
import groupsource from "../assets/images/insuranceLogos/groupsource.PNG";
import cooperator from "../assets/images/insuranceLogos/cooperator.PNG";
import canadaLife from "../assets/images/insuranceLogos/canadaLife.PNG";
import metlife from "../assets/images/insuranceLogos/metlife.PNG";
import deltaDental from "../assets/images/insuranceLogos/deltaDental.PNG";
import blueShield from "../assets/images/insuranceLogos/blueShield.png";
import groupAdministrators from "../assets/images/insuranceLogos/groupAdministrators.jpg";
import greatWest from "../assets/images/insuranceLogos/greatWest.png";
import aarp from "../assets/images/insuranceLogos/aarp.png";
import geha from "../assets/images/insuranceLogos/geha.png";
import premierAccess from "../assets/images/insuranceLogos/premierAccess.PNG";
import anthem from "../assets/images/insuranceLogos/anthem.PNG";
import libertyMutual from "../assets/images/insuranceLogos/libertyMutual.PNG";
import ameritas from "../assets/images/insuranceLogos/ameritas.webp";
import empireLife from "../assets/images/insuranceLogos/empireLife.PNG";
import libertyDental from "../assets/images/insuranceLogos/libertyDental.PNG";
import blueCrossBlueShield from "../assets/images/insuranceLogos/blueCrossBlueShield.png";
import pacificBlueCross from "../assets/images/insuranceLogos/pacificBlueCross.PNG";
import albertaBlueCross from "../assets/images/insuranceLogos/albertaBlueCross.PNG";
import WL from "../assets/images/insuranceLogos/WL.png";
import cignaDental from "../assets/images/insuranceLogos/cignaDental.PNG";
import aetna from "../assets/images/insuranceLogos/aetna.PNG";
import guardian from "../assets/images/insuranceLogos/guardian.png";
import unitedHealthCare from "../assets/images/insuranceLogos/unitedHealthCare.png";
import claimsecure from "../assets/images/insuranceLogos/claimsecure.png";
import sunlife from "../assets/images/insuranceLogos/sunlife.PNG";
import { ApiCalls } from "../api/allapiCall";
import axios from "axios";
import Error_image from "../assets/images/icons/Error_image.png";
import Success_image from "../assets/images/icons/Success_image.png";

export const appName = process.env.REACT_APP_APP_NAME;

export const DENTAL = "Dental";
export const VETERINARY = "Veterinary";
export const CANADA = "Canada";
export const UNITED_STATES = "United States";

export const SIKKA_ADMIN = "sikkaAdmin";

export const YES = "Yes";
export const NO = "No";
export const START = "Start";
export const STOP = "Stop";

export const EMAIL = "Email";
export const TEXT = "Text";

export const error_image = Error_image;
export const success_image = Success_image;

export const confirmBtn = "primary-btn";
export const cancelBtn = "secondary-btn";

export const countryPaymentProviders = {
    Canada: "moneris",
    "United States": "authorize.net",
};

export const sikkaScoreCellWidth = 190;

export const insuranceLogos = [
    { "Green Sheild Canada": gsc },
    { "Green Shield": gsc },
    { "Green Sheild of Canada": gsc },
    { "Green Shield of Canada": gsc },
    { Greensheild: gsc },
    { "Equitable Life": equitableLife },
    { OTIP: otip },
    { Manulife: canadaLife },
    { "Canada Life": canadaLife },
    { ManuLife: manulife },
    { "ManuLife Financial": manulife },
    { "Manulife Finanical": manulife },
    { "Manulife Financial": manulife },
    { "Manu Life": manulife },
    { "MDM Insurance Services Inc.": mdm },
    { "RWAM Insurance Administrators": rwam },
    { "RBC Life Insurance Company": rbc },
    { "RBC Insurance": rbc },
    { "SSQ Financial": ssq },
    { "Group Source": groupsource },
    { "Co-Operators": cooperator },
    { "Met Life": metlife },
    { "Delta USA": deltaDental },
    { "Delta of Illinois": deltaDental },
    { "Delta Of Illinios": deltaDental },
    { "Delta Of New Jersey": deltaDental },
    { "Blue Shield": blueShield },
    { "Blue Shield Of California": blueShield },
    { "Blue Shield Of California Dental Claims": blueShield },
    { "Blue Cross And Blue Shield Of Alabama": blueCrossBlueShield },
    { "Group Administrators Ltd": groupAdministrators },
    { "Great West": greatWest },
    { "AARP C/O Delta Dental": aarp },
    { GEHA: geha },
    { "Premier Access": premierAccess },
    { "Anthem Blue Cross": anthem },
    { "Liberty Mutual Insurance": libertyMutual },
    { Ameritas: ameritas },
    { "Empire Life": empireLife },
    { "Liberty Dental": libertyDental },
    { "Pacific Blue Cross": pacificBlueCross },
    { "Alberta Blue Cross": albertaBlueCross },
];

export const features = {
    //Table Columns
    PEWS: "Economic Well Being",
    Leca: "Health Risk",
    Insurance: "Insurance / Eligibility",
    //Eligibility: "Eligibility",
    Provider: "Provider",
    MedicalCondition: "Medical Condition",
    TimeProcedures: "Time & Procedures",
    ARBalance: "A/R Balance",
    TreatmentPlans: "Treatment Plans",
    // Payments: "Payments",

    // Main
    ActivityStream: "Activity Stream",
    //PredictedWeeklyProduction: "Production Prediction",
    Appointments: "Appointments",
    Messages: "Messages",
    EligibilityRequest: "Eligibility Request",
    MorningMeetingLite: "Morning Meeting Lite",
    Campaigns: "Campaigns",
    //SAIGE: "SAIGE",

    //Settings Page
    SikkaScores: "Sikka Scores",
    SchedulesandDuration: "Schedules and Duration",
    RegionalSettings: "Regional Settings",
    ProviderMapping: "Provider Mapping",
    UserManagementCreate: "Create Users",
    UserManagementModify: "Modify User Features",
    //SikkaScoresAutomation: "Sikka Scores Automation",
    //InsuranceEligibilityCredentials: "Insurance Eligibility Credentials",
    // PaymentAPIConfiguration: "Payment API Configuration",
};

export const enabledFeatures = {
    PEWS: false,
    Leca: false,
    Insurance: false,
    //Eligibility: false,
    Provider: false,
    MedicalCondition: false,
    TimeProcedures: false,
    ARBalance: false,
    TreatmentPlans: false,
    //Payments: false,
    ActivityStream: false,
    //PredictedWeeklyProduction: false,
    Appointments: false,
    Messages: false,
    EligibilityRequest: false,
    MorningMeetingLite: false,
    Campaigns: false,
    SikkaScores: false,
    SchedulesandDuration: false,
    RegionalSettings: false,
    ProviderMapping: false,
    UserManagementCreate: false,
    UserManagementModify: false,
    //SAIGE: false,
    //SikkaScoresTemplates: false,
    //SikkaScoresAutomation: false,
    //InsuranceEligibilityCredentials: false,
    //PaymentAPIConfiguration: false,
};

export const allFeatures = {
    PEWS: true,
    Leca: true,
    Insurance: true,
    Provider: true,
    MedicalCondition: true,
    TimeProcedures: true,
    ARBalance: true,
    TreatmentPlans: true,
    ActivityStream: true,
    //PredictedWeeklyProduction: true,
    Appointments: true,
    Messages: true,
    EligibilityRequest: true,
    MorningMeetingLite: true,
    Campaigns: true,
    SikkaScores: true,
    SchedulesandDuration: true,
    RegionalSettings: true,
    ProviderMapping: true,
    UserManagementCreate: true,
    UserManagementModify: true,
};

export const findInsuranceLogo = (name) => {
    const src = insuranceLogos.find((i) => Object.keys(i)[0] === name);
    if (src) return src[name];
    const n = name.toLowerCase().replaceAll(" ", "");
    if (n.includes("deltadental")) return deltaDental;
    if (n.includes("greatwestlife")) return WL;
    if (n.includes("cigna")) return cignaDental;
    if (n.includes("metlife")) return metlife;
    if (n.includes("aetna")) return aetna;
    if (n.includes("guardian")) return guardian;
    if (n.includes("unitedhealthcare")) return unitedHealthCare;
    if (n.includes("claimsecure")) return claimsecure;
    if (n.includes("sunlife")) return sunlife;
    return "";
};

export const SUPER_ADMIN = "Super Admin";
export const PRACTICE_ADMIN = "Practice Admin";
export const GROUP_ADMIN = "Group Admin";
export const REGULAR_USER = "Regular User";
export const FM = "Front Desk";
export const BM = "Business Manager";

export const IS_SUBSCRIBED = "isSubscribed";

export const TOTAL_PRODUCTION = "totalProduction";
export const ROI = "ROI";

export const DENTIST = "dentist";
export const HYGIENIST = "hygienist";
export const BOTH = "both";

export const AuthorizaModalId = "scoresViewingConditionModal";
export const ScoreDiableModalId = "scoreDiableModal";
export const TreatmentPlanModalId = "TreatmentPlanModal";
export const DetailsModalId = "PatientDetailsModal";

export const SELECT_PRACTICE__OR_GROUP_TIMESTAMP =
    "selectPracticeOrGroup_timestamp";

export const defaultPageSizes = [20, 50, 100];

///////////////////////////////////////////////////////
// STORE DATA IN BROWSER && Reducer
///////////////////////////////////////////////////////
const set = (location, key, data) => {
    location === "local"
        ? localStorage.setItem(key, JSON.stringify(data))
        : sessionStorage.setItem(key, JSON.stringify(data));
};

const get = (key) => {
    return (
        JSON.parse(sessionStorage.getItem(key)) ||
        JSON.parse(localStorage.getItem(key))
    );
};

export const store = {
    set,
    get,
};

export const logout = () => {
    const storedTimestamp = store.get(SELECT_PRACTICE__OR_GROUP_TIMESTAMP);

    sessionStorage.clear();
    localStorage.clear();

    // Keep the recently practice/group selection timestamp
    store.set("local", SELECT_PRACTICE__OR_GROUP_TIMESTAMP, storedTimestamp);

    location.reload();
    window.location = "/login";
};

///////////////////////////////////////////////////////
// RESULT DISPLAY POP UP
///////////////////////////////////////////////////////
///////////////////////////////////////////////////////
export const errorCodeDesc = {
    400: {
        title: "Bad request",
        text: "Please check your input",
        icon: "warning",
    },
    500: {
        title: "Internal server error",
        text: "Something wrong with the server",
        icon: "warning",
    },
    403: {
        title: "Forbidden",
        text: "You don't have access right to this content",
        icon: "warning",
    },
};

///////////////////////////////////////////////////////
// TIME
///////////////////////////////////////////////////////
export const monthName = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
];

export const monthFullName = [
    "January",
    "Febuary",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
];

export const monthOptions = [
    { value: "", label: "Month" },
    { value: "01", label: "01 - January" },
    { value: "02", label: "02 - February" },
    { value: "03", label: "03 - March" },
    { value: "04", label: "04 - April" },
    { value: "05", label: "05 - May" },
    { value: "06", label: "06 - June" },
    { value: "07", label: "07 - July" },
    { value: "08", label: "08 - August" },
    { value: "09", label: "09 - September" },
    { value: "10", label: "10 - October" },
    { value: "11", label: "11 - November" },
    { value: "12", label: "12 - December" },
];

export const formatCourseDate = (date, monthFormat) => {
    // format date from "YYYY-MM-DD" to "shortMonth DD, YYYY"
    const dateObj = new Date(date + "T00:00:00");
    return new Intl.DateTimeFormat("en-US", {
        year: "numeric",
        month: `${monthFormat ? monthFormat : "2-digit"}`,
        day: "2-digit",
    }).format(dateObj);
};

export const currentDate = new Date();
export const currentMonth = currentDate.toLocaleString("default", {
    month: "short",
}); // short format

export const yyyymmddToMmddyyyy = (inputDate) => {
    const [year, month, date] = inputDate.split("-");
    return `${month}-${date}-${year}`;
};

export const timeConverter = (time) => {
    // convert from 24hrs (13:00) to AM, PM format
    let hour = "";
    let unit = "AM";
    const splited = time.split(":");
    const h = splited[0];
    const minute = splited[1];
    if (parseInt(h) >= 0 && parseInt(h) <= 11) {
        if (h === "00") {
            hour = "12";
        } else {
            hour = h;
        }
    } else {
        if (h === "12") {
            hour = "12";
        } else {
            hour = (parseInt(h) - 12).toString();
        }
        unit = "PM";
    }
    return `${hour.length === 1 ? "0" : ""}${hour}:${minute} ${unit}`;
};

///////////////////////////////////////////////////////
// SORTING ALPHABETICALLY
///////////////////////////////////////////////////////
export const sortAlpha = (property) => {
    var sortOrder = 1;

    if (property[0] === "-") {
        sortOrder = -1;
        property = property.substr(1);
    }

    return function (a, b) {
        if (sortOrder == -1) {
            return b[property].localeCompare(a[property]);
        } else {
            return a[property].localeCompare(b[property]);
        }
    };
};

///////////////////////////////////////////////////////
// FORMAT DATES
///////////////////////////////////////////////////////

///////////////////////////////////////////////////////
// FORMAT A NUMBER TO CURRENCY
///////////////////////////////////////////////////////
export const toCurrencyConverter = (data) => {
    // data could be a string or a number. convert a number into currency with format like $25.20
    var formatter = new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD",
    });
    return formatter.format(data);
};

export const currencyToNumber = (amount) => {
    return Number(amount.replace(/[^0-9.-]+/g, ""));
};

// Sometimes when summing two decimals, the result is strange. for example, 1.6 + 3.2 = 4.80000000000001
// In order to avoid that, we use sumDecimals to remove 0.0000000000001
export const sumDecimals = (num1, num2) => {
    return Math.round((num1 + num2) * 1e12) / 1e12;
};

///////////////////////////////////////////////////////
// PHONE NUMBER REFORMAT
///////////////////////////////////////////////////////
export const getFormattedPhoneNum = (input) => {
    let output = "";
    input.replace(
        /^\D*(\d{0,3})\D*(\d{0,3})\D*(\d{0,4})/,
        (match, g1, g2, g3) => {
            if (g1.length) {
                output += g1;
                if (g1.length <= 3) {
                    if (g2.length) {
                        output += "-" + g2;
                        if (g2.length <= 3) {
                            if (g3.length) {
                                output += "-" + g3;
                            }
                        }
                    }
                }
            }
        },
    );
    return output;
};

//////////////////////////////////////////////////////////////////////////////////////////////////////////////
// KENDO TABLES SETTINGS
//////////////////////////////////////////////////////////////////////////////////////////////////////////////
export const loadingPanel = (
    <div className="k-loading-mask">
        <span className="k-loading-text">Loading</span>
        <div className="k-loading-image"></div>
        <div className="k-loading-color"></div>
    </div>
);

export const addPlaceHolder = (patientList, gridRef, index) => {
    if (patientList.length > 0) {
        let input = gridRef.current.getElementsByTagName("input");
        input[index].placeholder = "Search...";
    }
};

// SIKKA SCORE EMAIL AND TEXT ORIGINAL TEMPLATE
export const emailHeader =
    "<div class='sikkaScoresTemplateHeader' style='background: #ffffff; text-align: center;'><div style='text-align: center; width: 100%; font-family: Arial;'><h3 style='font-weight: bold;font-size:18px'>Get Payment Options that suit You</h3><hr/></div></div>";

export const emailFooter =
    "<div style='margin-top:32px;font-family: Arial;font-size:14px' class='sikkaScoresTemplateFooter'><a href='$SikkaScoreAuthorizedButton$' style='background: #fdca40; border: none; padding: 12px 24px; border-radius: 8px; font-weight: bold; color: black; text-decoration: none;' target='_blank'>Yes, I Authorize</a><div style='margin-top:24px;margin-bottom:4px'>Thank you</div><div style='margin-bottom:32px'><b>$PracticeName$</b></div><div>You are receiving this message because you have opted in for communications, and we will run you for eligibility.</div></div>";

export const initialEmailBody =
    "<div style='font-size:14px;font-family:Arial'><p>Dear <b>$FirstName$,</b><br />Our practice would like to help you with treatment plans and buy now pay later services. We are looking forward to seeing you in the practice in the near future. Your next appointment is on <b>$AppointmentDate$</b> at <b>$AppointmentTime$</b>. Please authorize us to run eligibility for you. This in no way impacts any credit history. It is internal for our practice and you have previously signed a consent form.</p></div>";

export const initialVetEmailBody =
    "<div><p>Dear <b>$FirstName$,</b><br />We understand that providing the best care for your cherished pet is of utmost importance to you. We strive to ensure that your furry companion receives the necessary treatments and care they deserve. To make this process more convenient for you, we'd like to help you with flexible treatment plans and buy now pay later services.<br />We look forward to welcoming you and your furry friend to our practice soon. Your pet's next appointment is scheduled for <b>$AppointmentDate$</b> at <b>$AppointmentTime$</b>. To proceed, we kindly request your authorization to assess eligibility for the available payment options. Please note that this assessment is purely internal and will not impact your credit history.</p></div>";

export const generateEmailTemplate = (emailToEdit) => {
    return (
        "<div style='max-width: 700px; margin: 0 auto'>" +
        emailHeader +
        emailToEdit +
        emailFooter +
        "</div>"
    );
};

export const emailMessage = generateEmailTemplate(initialEmailBody);
export const vetEmailMessage = generateEmailTemplate(initialVetEmailBody);

export const initialTextMessage =
    "Hi, this is $PracticeName$. May we check payment options available to you for tomorrow's treatment? No hit on your credit. Reply 'yes' to approve.";

export const sikkaScoreEmailSubject = "Get Payment Options that suit You";

export const welcomeEmailMessage =
    "<div><div style='background:#ffffff;width:700px;margin:0 auto;text-align:center;padding:20px'><div style='text-align:left;width:100%;font-family:Arial'><h3 style='font-weight:bold'>Welcome to the " +
        appName +
        "!</h3><hr><div><p>You are receiving this message as you recently signed into the " +
        appName +
        " for the first time. We would like to extend a warm welcome, and thank you for being a valued customer with Sikka Ai.</p><p>" +
        appName +
        " is a tool that provides you with a variety of insights for patients visiting your practice each day, such as Insurance Eligibility, Treatments Plans, and comprehensive patient profiles. You have also been granted access to the revolutionary Sikka Scores, and a sneak peek into how you can grow your monthly production.</p><p>We would like to inform you that you may access your " +
        appName +
        " in one of two ways. First you can use " +
        appName ===
    "Self-Driving Practice"
        ? "<a href='https://sdp.sikkasoft.com' target='_blank' rel='noreferrer'>https://sdp.sikkasoft.com</a>"
        : "<a href='https://prime.sikkasoft.com' target='_blank' rel='noreferrer'>https://prime.sikkasoft.com</a>" +
          " and sign in with your regular Sikka Account, or access the page through the Icon added to your desktop.</p><p>We thank you again for being our valued customer.</p><div><div>Best Regards,</div><div>The " +
          appName +
          " Team</div></div></div></div></div></div>";

// convert time in ISO_8601 format to defined format. Example of ISO_8601: "2010-01-01T05:06:07"
export const timestamp = (time, format) => {
    return moment(time, moment.ISO_8601).format("hh:mm:ss A, " + format);
};

export const modifyPatientData = async (data) => {
    const modifiedList = await Promise.all(
        data.map((p) => {
            const combinedProcedures = p.procedures.reduce(
                (prev, proc) =>
                    prev +
                    proc?.procedureName +
                    " " +
                    proc?.procedureCode +
                    " ",
                "",
            );

            const appointmentTime = p.appointmentTime.slice(0, 5);

            // Combine appointment time && procedures
            const time_procedures = `${timeConverter(
                appointmentTime,
            )} ${combinedProcedures}`;

            const displayArBalance =
                p.isAmtDueByPatient === "Yes"
                    ? p.arBalanceByPatient
                    : p.arBalance;

            // Combine Species and Breed for Pet
            if (p?.species && p?.breed) {
                const type = `${p.species} ${p.breed}`;

                return {
                    ...p,
                    fullName: `${p.firstName} ${p.lastName}`,
                    displayArBalance,
                    time_procedures,
                    type,
                    weight: parseFloat(p.weight),
                };
            }

            return {
                ...p,
                fullName: `${p.firstName} ${p.lastName}`,
                displayArBalance,
                time_procedures,
            };
        }),
    );

    return modifiedList;
};

// CHECK DUPLICATES IN AN ARRAY OF VALUES
export const hasDuplicates = (arr) => {
    return new Set(arr).size !== arr.length;
};

export const colors = {
    primaryClr: "#681c9a",
    secondaryClr: "#0496ff",
    primaryAccentClr: "#7ed321",
    textClr: "#414d55",
    lightTextClr: "#c4c4c4",
    lightBlueClr: "#f1f3fd",
};

export const whatIsSikkaScores =
    "The Health Risk and Economic Well-Being Scores are a set of unique scores to inform decision making when offering treatment and payment plans to patients.";

// convertLECA is used to convert the score from 0-2 to 0-100 scale
export const convertLECA = (scoreString) => {
    return (+scoreString * 100) / 2;
};

// Material UI light tooltip
export const LightTooltip = styled(({ className, ...props }) => (
    <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
    [`& .${tooltipClasses.tooltip}`]: {
        backgroundColor: theme.palette.common.white,
        color: "rgba(0, 0, 0, 0.87)",
        boxShadow: theme.shadows[1],
        fontSize: 11,
    },
}));

export const LightTooltipWithBorder = styled(({ className, ...props }) => (
    <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
    [`& .${tooltipClasses.tooltip}`]: {
        backgroundColor: theme.palette.common.white,
        color: "#000000",
        boxShadow: theme.shadows[1],
        fontSize: 12,
        border: "solid 1px #c4c4c4",
        padding: "16px",
    },
}));

export const fixedEmailContent = // fixed email contents for messaging feature
    (
        <Tooltip title="This section is not editable" placement="top">
            <div
                style={{
                    fontFamily: "Arial",
                    cursor: "not-allowed",
                    opacity: 0.7,
                }}
            >
                <div style={{ marginBlock: 24 }}>
                    <a
                        disabled={true}
                        style={{
                            background: "#fdca40",
                            border: "none",
                            padding: "12px 24px",
                            borderRadius: "8px",
                            fontWeight: "bold",
                            color: "black",
                            textDecoration: "none",
                            marginBottom: 15,
                        }}
                    >
                        Yes, I Authorize
                    </a>
                </div>

                <div>Thank you</div>
                <p>
                    <b>$PracticeName$</b>
                </p>

                <div>
                    You are receiving this message because you have opted in for
                    communications, and we will run you for eligibility.
                </div>
            </div>
        </Tooltip>
    );

export const maxCount = 150; // max count for text message for message feature

export const sortData = (dataList, key) => {
    return dataList.sort((a, b) => {
        if (a[key] > b[key]) return 1;
        if (a[key] < b[key]) return -1;
        if ((a[key] = b[key])) return 0;
    });
};

//////////////////////////////////////////////////////////////////
// Function to track activities of users in the application
//////////////////////////////////////////////////////////////////
const trackingReq = () => {
    const userInfo = store.get("userInfo");
    const username = store.get("sikka-username");
    const isSikkaAdmin = store.get("sikkaAdmin");
    return {
        masterId: userInfo?.masterId,
        userId: userInfo?.userId,
        ipAddress: userInfo?.ipAddress,
        machineName: userInfo?.machineName,
        userName: username,
        practiceId: getPracticeIds() ?? "1",
        domainName: userInfo?.domainName,
        accessBrowser: browserName,
        url: window.location.href,
        appName,
        isSikkaAdmin: isSikkaAdmin ? isSikkaAdmin : false,
    };
};

export const trackActivity = (itemType, itemName, itemFlow, practiceId) => {
    if (practiceId) {
        ApiCalls.authPostAPI("/Visit/VisitData", {
            ...trackingReq(),
            itemType,
            itemName,
            itemFlow,
            practiceId,
        });
    } else {
        ApiCalls.authPostAPI("/Visit/VisitData", {
            ...trackingReq(),
            itemType,
            itemName,
            itemFlow,
        });
    }
};

// convert YYYY-MM-DD string to MMM DD, YYYY format
export const formatISOtoShortMonthDate = (isoDateString) => {
    if (isoDateString) {
        const date = new Date(isoDateString);
        const options = {
            year: "numeric",
            month: "short",
            day: "2-digit",
            timeZone: "UTC",
        };
        const formattedDate = new Intl.DateTimeFormat("en-US", options).format(
            date,
        );

        return formattedDate;
    } else return "";
};

export const maskEmail = (email) => {
    const [username, remaining] = email.split("@");
    const [server, domain] = remaining.split(".");

    let maskedUsername = "";
    for (let i = 0; i < username.length; i++) {
        if (i < 4) {
            maskedUsername += username[i];
        } else {
            maskedUsername += "*";
        }
    }

    let maskedServer = "";
    for (let i = 0; i < server.length; i++) {
        maskedServer += "*";
    }

    return maskedUsername + "@" + maskedServer + "." + domain;
};

export const initialErrObj = {
    min: false,
    max: false,
    lowercase: false,
    uppercase: false,
    specialChar: false,
    number: false,
    matching: false,
};

export const validatePassword = (passwordString, passwordConfirmString) => {
    const errObj = { ...initialErrObj };

    if (passwordString.length < 8) errObj["min"] = true;
    if (passwordString.length > 20) errObj["max"] = true;
    if (!/[a-z]/.test(passwordString)) errObj["lowercase"] = true;
    if (!/[A-Z]/.test(passwordString)) errObj["uppercase"] = true;
    if (!/[~!@#$%^&*()-+]/.test(passwordString)) errObj["specialChar"] = true;
    if (!/\d/.test(passwordString)) errObj["number"] = true;
    if (passwordString !== passwordConfirmString) errObj["matching"] = true;

    return errObj;
};

export const getPracticeList = async (masterId, practiceId) => {
    try {
        const practiceList = await ApiCalls.authGetAPI(
            "/UserAccount/PracticeData",
            {
                masterId,
                practiceId,
            },
        );

        const formattedPracticeList = practiceList.map((p) => ({
            ...p,
            custID: parseInt(p.custID),
        }));

        return formattedPracticeList;
    } catch (err) {
        console.log(err);
        return [];
    }
};

// Method to get a array of practiceIds unique among all groups and practices
export const getUniquePracticeIds = (practices, groups) => {
    const uniquePracticeIds = new Set();
    practices.forEach((practice) => {
        uniquePracticeIds.add(practice.practiceId);
    });

    groups.forEach((group) => {
        group.practiceGroupItems.forEach((item) => {
            uniquePracticeIds.add(item.practiceId);
        });
    });

    return Array.from(uniquePracticeIds);
};

export const removeUnderscore = (str) => {
    return str.replace(/_/g, " ");
};
export const getIpAddress = async () => {
    try {
        const { data } = await axios.get("https://ipwho.is/");
        return {
            ip: data?.ip ?? "",
            city: data?.city ?? "",
            region: data?.region ?? "",
            latitude: data?.latitude ?? "",
            longitude: data?.longitude ?? "",
            postal: data?.postal ?? "",
        };
    } catch (error) {
        console.error("Error fetching IP address:", error.message || error);
        return {
            ip: "",
            city: "",
            region: "",
            latitude: "",
            longitude: "",
            postal: "",
        };
    }
};

export const timezoneList = [
    { label: "Eastern Time Zone (UTC-05)", value: "UTC-05" },
    { label: "Central Time Zone (UTC-06)", value: "UTC-06" },
    { label: "Mountain Time Zone (UTC-07)", value: "UTC-07" },
    { label: "Pacific Time Zone (UTC-08)", value: "UTC-08" },
    { label: "Hawaii - Aleutian Time Zone (UTC-10)", value: "UTC-10" },
];

export const getRegionalOptions = async (masterId, selectedCulture) => {
    try {
        const queryParams = {
            masterId,
            selectedCulture,
        };

        const res = await Promise.all([
            ApiCalls.authGetAPI("/Setting/LoadPositiveCurrency", queryParams),
            ApiCalls.authGetAPI("/Setting/LoadNegativeCurrency", queryParams),
            ApiCalls.authGetAPI("/Setting/LoadDateAndTime", queryParams),
        ]);

        return res;
    } catch (err) {
        console.log(err);
        return null;
    }
};

// =========================================================================================
// START ============================= REGIONAL SETTINGS ===================================
// =========================================================================================

// All the time patterns in our database:
// "h:mm tt"
// hh:mm tt
// HH:mm
// H:mm
// Date pattern:
// MMM d, yyyy
// M/d/yyyy
// M/d/yy
// yyyy-MM-dd
// d/M/yyyy
// d/M/yy
// d MMM yyyy
// dd/MM/yyyy
// d MMM yyyy

// Format time with format "12:04:00" or "12:04"
// This function is used for formatting time based on Regional Settings
export const formatTime = (timeString, format) => {
    const [hourString, minute] = timeString.split(":"); // eslint-disable-line
    const hour = parseInt(hourString);
    const ampm = hour >= 12 ? "PM" : "AM";

    switch (format) {
        case "h:mm tt":
            return `${hour % 12 || 12}:${minute} ${ampm}`;

        case "hh:mm tt": // 01:05 AM
            return `${(hour % 12 || 12)
                .toString()
                .padStart(2, "0")}:${minute} ${ampm}`;

        case "HH:mm": // 13:20
            return `${hourString}:${minute}`;

        case "H:mm": // 1:20
            return `${hour}:${minute}`;

        default:
            return timeString;
    }
};

const calculateLongHour = (hour, ampm) => {
    let h = hour;
    if (ampm === "PM" && hour < 12) {
        h += 12;
    } else if (ampm === "AM" && hour === 12) {
        h = 0;
    }
    return h;
};

// Format time with format "03:04 PM" or "03:04 AM"
// This function is used for formatting time based on Regional Settings
export const formatTime2 = (timeString, format) => {
    const [num, ampm] = timeString.split(" ");
    const [hourString, minute] = num.split(":");

    const hour = parseInt(hourString);
    // 00:00 >> 12:00 AM
    // 12:00 >> 12:00 PM

    switch (format) {
        case "h:mm tt":
            return `${hour}:${minute} ${ampm}`;

        case "hh:mm tt":
            return timeString;

        case "HH:mm": // 13:20
            return `${calculateLongHour(hour, ampm)
                .toString()
                .padStart(2, "0")}:${minute}`;

        case "H:mm": // 1:20
            return `${calculateLongHour(hour, ampm)}:${minute}`;

        default:
            return timeString;
    }
};

const formatNegativeNumber = (negativeNumber, format) => {
    return format.replace("n", negativeNumber.toString().replaceAll("-", ""));
};

const formatPositiveNumber = (positiveNumber, format) => {
    return format.replace("n", positiveNumber.toString());
};

const formatDigitNumber = (num, digits) => {
    switch (digits) {
        case "0":
            return Math.round(num).toLocaleString();
        case "1": {
            const roundedNum = Math.round(num * 10) / 10; // 23.34 >> 23.3, 23.35 >> 23.4
            const num_string_with_digit = roundedNum.toFixed(1); // 23.4 >> 23.4 || 23 >> 23.0
            return (
                roundedNum.toLocaleString().split(".")[0] +
                "." +
                num_string_with_digit.split(".")[1]
            );
        }
        case "2": {
            const roundedNum = Math.round(num * 100) / 100; // 23.34 >> 23.3, 23.35 >> 23.4
            const num_string_with_digit = roundedNum.toFixed(2); // 23.4 >> 23.4 || 23 >> 23.0
            return (
                roundedNum.toLocaleString().split(".")[0] +
                "." +
                num_string_with_digit.split(".")[1]
            );
        }
    }

    return num.toLocaleString();
};

export const formatNumber = (num, formats) => {
    try {
        // Check if `num` is numeric
        if (
            isNaN(num) ||
            num === null ||
            num === undefined ||
            typeof num === "boolean"
        ) {
            console.log("Invalid number:", num);
            return num; // Return the input as-is or handle it according to your requirements
        }

        // first format digit
        // then, format negative
        const n = formatDigitNumber(num, formats.NumberDecimalDigits);

        if (parseFloat(n) < 0) {
            return formatNegativeNumber(n, formats.NumberNegativePattern);
        }
        return n;
    } catch (err) {
        console.log(err);
    }
    return num;
};

export const formatCurrency = (num, formats) => {
    if (isNaN(num) || isNaN(parseFloat(num))) return num;
    // first format digit
    // then, format positive/negative
    const n = formatDigitNumber(num, formats.CurrencyDecimalDigits);
    if (parseFloat(n) < 0) {
        return formatNegativeNumber(n, formats.CurrencyNegativePattern);
    } else {
        return formatPositiveNumber(n, formats.CurrencyPositivePattern);
    }
};

// =========================================================================================
// END =============================== REGIONAL SETTINGS ===================================
// =========================================================================================

export const allRightsReserved = () => {
    return `© ${new Date().getFullYear()} Sikka Software Corporation. All Rights Reserved.`;
};

// format number like 14355 to 14,355
export const formatInteger = (num = 0) => {
    return num.toLocaleString();
};

export const saigeQuestions = [
    "How many active patients do I have",
    "Who went inactive in the last 12 months",
    "What is the total collection for this month",
    "List of new patients in the last 1 month",
    "Who cancelled their appointments last week but did not reschedule",
];

export const capitalizeWords = (str) => {
    try {
        return str.replace(/\b\w/g, (char) => char.toUpperCase());
    } catch (err) {
        return "";
    }
};

export const reactSelectCustomStyles = {
    dropdownIndicator: (provided) => ({
        ...provided,
        color: "#474545",
    }),
    indicatorSeparator: (provided) => ({
        ...provided,
        display: "none",
    }),
};

export const swalMessage = (icon, title, text) => {
    const msg = {
        imageUrl:
            icon === "success"
                ? success_image
                : icon === "error"
                  ? error_image
                  : "",
        imageHeight: 66,
        text,
        customClass: {
            confirmButton: confirmBtn,
        },
    };
    if (!title) {
        Swal.fire(msg);
    } else {
        Swal.fire({ ...msg, title });
    }
};

export const showErrorMessage = (message) => {
    swalMessage(
        "error",
        "Error",
        message ? message : "Something went wrong. Please try again.",
    );
};

// This function helps extract the text from an HTML string
// for example, "<p>Hello world</p>" will return "Hello world"
export const extractTextFromHtml = (htmlString) => {
    try {
        const parser = new DOMParser();
        const doc = parser.parseFromString(htmlString, "text/html");
        return doc.body.textContent || "";
    } catch (err) {
        console.log(err);
        return "";
    }
};

export const combineStore = (addDataToStore, key, value) => {
    store.set("session", key, value);
    addDataToStore(key, value);
};

// If two arrays such as ["1", "2", "3"] and ["1", "2", "3"] are the identical, it returns true (regardless of the order of the elements)
export const haveSameMembers = (arr1, arr2) => {
    return (
        arr1.length === arr2.length &&
        new Set(arr1).size === new Set([...arr1, ...arr2]).size
    );
};

export const generateSikkaScoresSuccessMessage = (practices) => {
    const init = "You have successfully enabled Sikka Scores";
    if (practices.length === 1) {
        return `${init} for practice '${practices[0].practiceName}'.`;
    } else if (practices.length > 1) {
        const practiceNames = practices.map((p) => `'${p.practiceName}'`);
        const lastPractice = practiceNames.pop();
        return `${init} for practices ${practiceNames.join(
            ", ",
        )} and ${lastPractice}.`;
    }
    return init;
};

export const validateTextTemplate = (textToEdit) => {
    const foundYes = textToEdit.includes("'yes'");
    if (!foundYes) {
        swalMessage(
            "error",
            "Text Template Error",
            "The Text Template must include instructions for recipients to reply with 'yes' to provide their consent. Please ensure 'yes' is mentioned in the message to guide recipients effectively. You can refer to the default template.",
        );
        return false;
    }
    return true;
};

export const paymentInitEmail = `<div><div>Dear <strong>$FirstName$</strong>,</div><div> I hope this message finds you well. This is a friendly reminder that a payment of <strong>$Amount$</strong> is due.<div>If you have any questions or need assistance, feel free to contact us at <strong>$PracticePhone$</strong>. We're happy to help!</div><div>Thank you for choosing <strong>$PracticeName$</strong>. We appreciate your prompt attention to this matter.</div><div style="margin-top: 20px;"> Best regards,<br><strong>$PracticeName$</strong><br> Phone: <span style="color: #681c9a">$PracticePhone$</span></div></div>`;
export const paymentInitEmailSubject_Dental =
    "Payment Reminder for Your Recent Dental Visit";
export const paymentInitEmailSubject_Vet =
    "Payment Reminder for Your Recent Vet Visit";
export const paymentInitText =
    "Hi $FirstName$, this is $PracticeName$. A payment of $Amount$ is due.";
export const fixedText =
    " Pay securely at $PaymentLink$ or call us at $PracticePhone$.";
export const fixedEmail = `<div style="padding: 0 16px 16px 16px;">To make the payment, please use the secure link below: <p style="margin: 10px 0;"><a href="$PaymentLink$" style="color: #681c9a" target="_blank" rel="noopener noreferrer"> $PaymentLink$ </a></p></div>`;
export const fixedEmailNoPad = `<div>To make the payment, please use the secure link below: <p style="margin: 10px 0;"><a href="$PaymentLink$" style="color: #681c9a" target="_blank" rel="noopener noreferrer"> $PaymentLink$ </a></p></div>`;
export const fixedNote =
    "Note: The section below is fixed and will be included automatically in your message. It cannot be edited";
export const fixedEmailNote = `<div style="font-size: 12px; color: #888; margin: 10px 0;">
  Note: The section below is fixed and will be included automatically in your message. It cannot be edited.
</div>`;

export const fixedEmailNotePad = `<div style="font-size: 12px; color: #888; padding: 16px; margin-top: 10px;">
  Note: The section below is fixed and will be included automatically in your message. It cannot be edited.
</div>`;

//To check if two arrays have the same elements and the same length
export const twoListsAreSame = (arr1, arr2) => {
    // Check if lengths are the same
    if (arr1.length !== arr2.length) return false;

    // Sort both arrays
    const sortedArr1 = [...arr1].sort();
    const sortedArr2 = [...arr2].sort();

    // Compare sorted arrays
    return sortedArr1.every((value, index) => value === sortedArr2[index]);
};

export const generateMachineName = () => {
    const ip = store.get("ip");
    return `${ip.city}|${ip.region}|${ip.latitude}|${ip.longitude}|${ip.postal}`;
};

export const getPracticeIds = () => {
    try {
        const activeItem = store.get("activeItem");
        return activeItem.items.map((item) => item.practiceId).join(",");
    } catch (err) {
        console.log(err);
    }
    return "1";
};

export const getPracticeIdArray = () => {
    try {
        const activeItem = store.get("activeItem");
        return activeItem.items.map((item) => item.practiceId);
    } catch (err) {
        console.log(err);
    }
    return [];
};

export const getCustIds = () => {
    try {
        const activeItem = store.get("activeItem");
        return activeItem.items.length > 1 ? 1 : activeItem.items[0]["custId"];
    } catch (err) {
        console.log(err);
    }
    return 1;
};

// use to get the filter object for Kendo tables
export const getFiltersByFieldName = (state, fieldName) => {
    if (state?.filter && state?.filter?.filters) {
        const filters = state?.filter.filters;
        const filteredFilters = filters.filter((filter) => {
            return (
                filter.filters &&
                filter.filters.some(
                    (subFilter) => subFilter.field === fieldName,
                )
            );
        });
        return filteredFilters;
    }
    return null;
};

export const generatePendingAptSubject = (appointmentDate) => {
    return `Please Confirm Your Appointment on ${appointmentDate}`;
};

export const generatePendingAptEmail = (
    recordData,
    appointmentDate,
    practiceData,
) => {
    return `<p>Hello ${recordData.patientName},</p><p>This is a reminder of your upcoming appointment with <strong>${recordData.provider}</strong>.</p><div><strong>Appointment Details:</strong></div><div><strong>Date:</strong> ${appointmentDate}</div><div><strong>Time:</strong> ${recordData.apptTime}</div><p><strong>Location:</strong>${practiceData.address1}, ${practiceData.address2} ${practiceData.city}, ${practiceData.state}-${practiceData.zip}</p><p>Please confirm your appointment by clicking the link below Or call us at <strong>${practiceData.phone}</strong>. If you need to reschedule or cancel, kindly inform us at least 24 hours in advance to accommodate other patients.</p><p>We look forward to seeing you.</p><div>Best regards,</div><div><strong>${practiceData.practiceName}</strong></div><div>${practiceData.phone}</div>`;
};

export const generatePendingAptText = (
    recordData,
    appointmentDate,
    practiceData,
) => {
    return `Hi ${recordData.patientName}, this is a reminder of your appointment with ${recordData.provider} on ${appointmentDate} at ${recordData.apptTime}. Please confirm your appointment by replying 'Y' to confirm or call ${practiceData.phone} if you need to reschedule. Thank you!`;
};

// Export sanitization utilities
export { sanitizeHtml, sanitizeHtmlStrict, stripHtml } from "./sanitize";

export const customer_support_url =
    "https://support.sikka.ai/_hcms/mem/login?redirect_url=https%3A%2F%2Fsupport.sikka.ai%2Ftickets-view";
